import React from 'react';
import {
  Button,
  ParagraphText,
  Popover,
  StackLayout,
} from '@leagueplatform/genesis-core';

export function PopOver(props: any) {
  const { content, title } = props;
  // const [open, setOpen] = useState(false);

  return (
    <StackLayout css={{ display: 'inline' }} data-testid="titleTolltip">
      {/* <Popover.Root open={open}> */}
      <Popover.Root>
        <Popover.Trigger>
          <Button
            priority="tertiary"
            quiet
            size="small"
            icon="statusInformationCircle"
            hideLabel
            // onMouseOver={() => setOpen(true)}
            // onMouseLeave={() => setOpen(false)}
            // onClick={(e) => e.preventDefault()}
            css={{
              padding: '$none',
              marginLeft: '$half',
              position: 'relative',
            }}
          >
            {title}
          </Button>
        </Popover.Trigger>
        <Popover.Content
          align="start"
          side="bottom"
          showCloseButton={false}
          css={{
            zIndex: 999999999,
            display: 'block',
            borderRadius: '$none',
            boxShadow: 'none',
            border: '1px solid #66717A',
            maxWidth: 285,
            padding: '12px !important',
            top: '3px',
            position: 'relative',
            '.GDS-popover-content': {
              display: 'block',
              width: '600px',
            },
          }}
        >
          <StackLayout horizontalAlignment="center">
            <ParagraphText
              css={{
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '24px',
                letterSpacing: '-0.176px',
              }}
            >
              {content}
            </ParagraphText>
          </StackLayout>
        </Popover.Content>
      </Popover.Root>
    </StackLayout>
  );
}
